import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { updateTokensInLocalStorage } from '@/helpers';

interface TokensState {
  balance: number;
  plans: {
    id: string;
    name: string;
    tokens: number;
    price: number;
    features: string[];
  }[];
  transactions: {
    id: string;
    type: 'purchase' | 'usage';
    amount: number;
    date: string;
    description: string;
  }[];
  loading: boolean;
  error: string | null;
}

const initialState: TokensState = {
  balance: 0,
  plans: [],
  transactions: [],
  loading: false,
  error: null,
};

export const tokensSlice = createSlice({
  name: 'tokens',
  initialState,
  reducers: {
    fetchBalanceStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchBalanceSuccess: (state, action: PayloadAction<number>) => {
      state.balance = action.payload;
      state.loading = false;
      updateTokensInLocalStorage(action.payload);
    },
    fetchBalanceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addTokens: (state, action: PayloadAction<number>) => {
      state.balance += action.payload;
      updateTokensInLocalStorage(state.balance);
    },
    useTokens: (state, action: PayloadAction<number>) => {
      state.balance = Math.max(0, state.balance - action.payload);
      updateTokensInLocalStorage(state.balance);
    },
    addTransaction: (state, action: PayloadAction<Omit<TokensState['transactions'][0], 'id'>>) => {
      state.transactions.unshift({
        ...action.payload,
        id: Date.now().toString(),
      });
    },
    fetchTransactionsSuccess: (state, action: PayloadAction<TokensState['transactions']>) => {
      state.transactions = action.payload;
    },
  },
});

export const {
  fetchBalanceStart,
  fetchBalanceSuccess,
  fetchBalanceFailure,
  addTokens,
  useTokens,
  addTransaction,
  fetchTransactionsSuccess,
} = tokensSlice.actions;

export default tokensSlice.reducer;
